import dayjs from "dayjs";
import currencyFormatter from "currency-formatter";

export const currency = (
  val,
  unformat = false,
  symbolNon = false,
  ifNull = false,
  precision,
  symbolDefault,
  skipPrefix
) => {
  // const { options } = store.getState().options;
  const options = {};
  let symbol = "";
  // tidak terpakai, karena sudah menggunakan alurbisnis
  if (symbolNon) {
    symbol = "";
  }

  if (options.show_property_currency_symbol === 1) {
    if (symbolDefault) {
      symbol = symbolDefault;
    } else {
      symbol = options.property_currency_symbol
        ? `${options.property_currency_symbol} `
        : "Rp ";
    }
  }

  if (skipPrefix) {
    symbol = "";
  }

  if (precision === undefined) {
    if (options.property_decimal !== null) {
      precision = options.property_decimal;
    } else {
      precision = 0;
    }
  }

  let format = { symbol, decimal: ".", precision: 0 };
  if (options.property_currency_format === "0.,") {
    format = { symbol, thousand: ".", precision: 0 };
  } else if (options.property_currency_format === "2-.") {
    format = { symbol, thousand: "", decimal: ".", precision };
  } else if (options.property_currency_format === "2-,") {
    format = { symbol, thousand: "", decimal: ",", precision };
  } else if (options.property_currency_format === "2.,") {
    format = { symbol, thousand: ".", decimal: ",", precision };
  } else if (options.property_currency_format === "2,.") {
    format = { symbol, thousand: ",", decimal: ".", precision };
  } else if (options.property_currency_format === "2 .") {
    format = { symbol, thousand: " ", decimal: ".", precision };
  } else if (options.property_currency_format === "2 ,") {
    format = { symbol, thousand: " ", decimal: ",", precision };
  }
  let result;
  if (unformat) {
    val = `${val || ""}`.split(format.thousand || "").join("");
    result = currencyFormatter.unformat(val || 0, format);
  } else {
    result = currencyFormatter.format(val || 0, format);
  }

  if (ifNull && result === "0") {
    return "-";
  }
  if (unformat === "format") {
    return format;
  }
  return result;
};
export const formatDateDB = (date = new Date()) => {
  const newDate = dayjs(date);

  return newDate.isValid() ? newDate.format("YYYY-MM-DD") : "";
};

export const formatDate = (date = new Date()) => {
  const newDate = dayjs(date);

  return newDate.isValid() ? newDate.format("DD MMMM YYYY") : "";
};

export const formatDateText = () => "YYYY-MM-DD";
// (store.getState().options &&
//   store.getState().options.options &&
//   store.getState().options.options.property_date_format) ||
//

export const qtyToCurrencyAutoComma = ({ value, maxPrecision }) => {
  const newValue = parseFloat(parseFloat(value).toFixed(10));
  const precision = `${newValue}`.includes(".")
    ? `${newValue}`.split(".")[1].length
    : 0;

  return currency(
    newValue,
    false,
    true,
    false,
    typeof maxPrecision === "number"
      ? precision > maxPrecision
        ? maxPrecision
        : precision
      : precision,
    "",
    true
  );
};

export const formatTime = (time) => {
  const now = dayjs();
  const messageTime = dayjs(time);

  // Kondisi 1: Dalam 1 jam terakhir
  if (now.diff(messageTime, "hour") < 1) {
    return messageTime.fromNow(); // Contoh: "just now", "10 minutes ago"
  }

  // Kondisi 2: Hari yang sama
  if (messageTime.isToday()) {
    return messageTime.format("HH:mm"); // Contoh: "14:30"
  }

  // Kondisi 3: Beda hari
  return messageTime.format("DD MMM HH:mm"); // Contoh: "25 Sep 14:30"
};

export const toDbFormat = (date) => dayjs(date).format("YYYY-MM-DD");
